import styled from 'styled-components';

import { Button } from 'components/ui';
import { Theme } from 'utils/color/horizonTheme';

export const StyledBanner = styled.div<{ $gridGap?: string }>`
  background: ${({ theme }) => theme.tableBannerBackgroundColor};
  color: ${({ theme }) => theme.headerColor};

  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-gap: ${({ $gridGap }) => $gridGap ?? 'unset'};
  padding: 0.25rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  animation: slide-down 0.4s ease-out;

  .ant-divider {
    height: 1.25em;
    border-width: 2px;
  }

  @keyframes slide-down {
    0% {
      opacity: 0;
      margin-top: -40px;
    }

    100% {
      opacity: 1;
      margin-top: 0;
    }
  }
`;

export const StyledTitle = styled.span`
  margin-right: 0.5rem;
`;

export const ItalicText = styled.span`
  font-style: italic;
`;

export const StyledButton = styled(Button)`
  position: relative;
  height: 1.5rem;
  width: 1.5rem;
  border: none;
  box-shadow: none;
  background: transparent;

  &:hover,
  &:focus {
    background-color: inherit;
  }

  .anticon {
    display: flex;
    color: ${({ theme }) => theme.teal};
  }
`;

export const StyledLink = styled(Button)`
  color: ${({ theme }) =>
    theme.themeName === Theme.Dark ? theme.tealActive : theme.teal} !important;
  padding: 0;

  &:hover,
  &:active {
    color: ${({ theme }) => theme.tealActive} !important;
  }
`;
